export default "__VITE_ASSET__BeglOTw5__"